// src/components/LoggedOut/FavoritesLogic/FavoritesDrawer.jsx

import React from "react";
import { Drawer } from "antd";
import PropTypes from "prop-types";
import BookmarksSectionFavorites from "../FavoritesLogic/BookmarksSectionFavorites";

export default function FavoritesDrawer({
    visible,
    onClose,
    favorites,
    onRemoveFavorite,
  }) {
    return (
      <Drawer
        title="Mis favoritos"
        placement="right"
        onClose={onClose}
        open={visible}
        width={320}
        bodyStyle={{ padding: 16, backgroundColor: "#ffffff" }}
        className="favorites-drawer"
      >
        <BookmarksSectionFavorites
          favorites={favorites}
          onRemoveFavorite={onRemoveFavorite}
          onClose={onClose}
        />
      </Drawer>
    );
  }
  
  FavoritesDrawer.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    favorites: PropTypes.array.isRequired,
    onRemoveFavorite: PropTypes.func.isRequired,
  };